<!-- <div class="flex flex-col max-h-screen -m-6 overflow-hidden">
    <div class="flex flex-0 justify-end h-6">
        <button mat-icon-button (click)="closeModal()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>
    <div class="m-5 gap-2">
        <span class="heading-h4">{{ 'GENERAL.ABOUT' | transloco }}</span>
        <p>{{ 'SETTINGS.VERSION' | transloco}} <span style="font-weight: bold"> {{version}}</span></p>
    </div>
</div> -->

<div class="flex flex-col max-h-screen -m-6 overflow-hidden">
    <div class="flex flex-0 justify-end h-8">
        <mat-icon class="icon-size-5 close-popup" [svgIcon]="'heroicons_outline:x'" (click)="closeModal()">
        </mat-icon>
    </div>
    <span class="flex flex-col flex-auto overflow-y-auto px-8 pb-8 gap-2">
        <span class="heading-h4">{{ 'GENERAL.ABOUT' | transloco }}</span>
        <!-- <p>{{ 'SETTINGS.VERSION' | transloco}} <span style="font-weight: bold"> {{version}}</span></p> -->
        <span class="font-medium text-secondary">
            <span class="text-logo-secondary">{{ "WELCOME_FIRSTNAME" | transloco }}</span>
            <span class="text-logo"> {{ "WELCOME_LASTNAME" | transloco }}</span>
            &copy; {{ currentYear }} - {{ appVersion }}
        </span>
    </span>
</div>